import { cn } from '@/shared/lib/cn';

import { Icon, type IconName } from './Icon';
import { Skeleton } from './Skeleton';

type Tone = 'brand' | 'success' | 'warning' | 'danger' | 'neutral';

const tones: Record<Tone, string> = {
  brand: 'bg-brand-50 text-brand-600',
  success: 'bg-success-50 text-success-700',
  warning: 'bg-warning-50 text-warning-700',
  danger: 'bg-danger-50 text-danger-700',
  neutral: 'bg-ink-100 text-ink-600',
};

/**
 * Indicador do painel.
 *
 * Zero e um valor legitimo e aparece como zero. Um painel que esconde o zero ou o
 * troca por um numero de exemplo ensina a nao confiar nele.
 */
export function KpiCard({
  label,
  value,
  hint,
  icon,
  tone = 'brand',
  loading,
}: {
  label: string;
  value: string;
  hint?: string | undefined;
  icon: IconName;
  tone?: Tone | undefined;
  loading?: boolean | undefined;
}) {
  return (
    <article className="surface-card flex items-start gap-3.5 p-4">
      <span
        aria-hidden
        className={cn(
          'flex size-9 shrink-0 items-center justify-center rounded-lg',
          tones[tone],
        )}
      >
        <Icon name={icon} size={17} />
      </span>

      <div className="min-w-0 flex-1">
        <p className="text-2xs font-medium uppercase tracking-wide text-ink-500">
          {label}
        </p>
        {loading ? (
          <Skeleton className="mt-1.5 h-6 w-20" />
        ) : (
          <p className="mt-0.5 truncate text-xl font-semibold tabular-nums text-ink-900">
            {value}
          </p>
        )}
        {hint ? <p className="mt-0.5 truncate text-2xs text-ink-500">{hint}</p> : null}
      </div>
    </article>
  );
}
